import React, { useState, useEffect } from 'react';

export default function EventFormSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    companyName: '',
    eventDate: '',
    eventHours: '',
    guestCount: '',
    eventCharacter: '',
    drinks: '',
    alcohol: '',
    catering: '',
    djMusic: '',
    budget: '',
    additionalQuestions: '',
    source: '',
    regulationAccepted: false,
    dataProcessingAccepted: false
  });

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^(\+48\s?)?[\d\s\-\(\)]{9,}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  const validateDate = (date) => {
    if (!date) return true;
    const selectedDate = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate >= today;
  };

  useEffect(() => {
    const newErrors = {};

    if (formData.name && formData.name.length < 2) {
      newErrors.name = 'Imię i nazwisko musi mieć przynajmniej 2 znaki';
    }

    if (formData.email && !validateEmail(formData.email)) {
      newErrors.email = 'Nieprawidłowy format adresu email';
    }

    if (formData.phone && !validatePhone(formData.phone)) {
      newErrors.phone = 'Nieprawidłowy format numeru telefonu';
    }

    if (formData.eventDate && !validateDate(formData.eventDate)) {
      newErrors.eventDate = 'Data wydarzenia nie może być w przeszłości';
    }

    setErrors(newErrors);

    const requiredFieldsFilled = formData.name && formData.email && formData.phone && 
                                 formData.regulationAccepted && formData.dataProcessingAccepted;
    const noValidationErrors = Object.keys(newErrors).length === 0;
    setIsFormValid(requiredFieldsFilled && noValidationErrors);
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid || isSubmitting) return;

    setIsSubmitting(true);
    setSubmitMessage({ type: '', text: '' });

    try {
      const response = await fetch('https://wawaproxy.pl/QYXB1GExPyvbZuKtjRDx29YJpN1xz4sStRDHy3ejxyRmBK0jyA4aWk4z0RZmFC2f', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Secret-Key': 'Mxw9FrEErQgPUGghBJSaFxzZxuDr91F7G6qNqkXj7hNdJ5XY0DcfsZe8hxNVYNDG'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitMessage({ 
          type: 'success', 
          text: 'Dziękujemy! Twoje zapytanie zostało wysłane pomyślnie. Skontaktujemy się z Tobą najszybciej jak to możliwe, aby omówić szczegóły Twojej imprezy.' 
        });
        // Resetowanie formularza po udanym wysłaniu
        setFormData({
          name: '',
          email: '',
          phone: '',
          eventType: '',
          companyName: '',
          eventDate: '',
          eventHours: '',
          guestCount: '',
          eventCharacter: '',
          drinks: '',
          alcohol: '',
          catering: '',
          djMusic: '',
          budget: '',
          additionalQuestions: '',
          source: '',
          regulationAccepted: false,
          dataProcessingAccepted: false
        });
      } else {
        setSubmitMessage({ 
          type: 'error', 
          text: 'Przepraszamy, wystąpił problem podczas wysyłania formularza. Spróbuj ponownie za chwilę lub skontaktuj się z nami bezpośrednio.' 
        });
      }
    } catch (error) {
      console.error('Błąd podczas wysyłania formularza:', error);
      setSubmitMessage({ 
        type: 'error', 
        text: 'Przepraszamy, wystąpił problem z połączeniem. Sprawdź połączenie internetowe i spróbuj ponownie.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNumberChange = (name, increment) => {
    const currentValue = parseInt(formData[name]) || 0;
    const newValue = Math.max(0, currentValue + increment);
    setFormData(prev => ({
      ...prev,
      [name]: newValue.toString()
    }));
  };

  return (
    <section id="EventForm">
      <div className="section">
        <div className="sectionCol" style={{ flex: '100%' }}>
          <div>
            <h1 className="tac">Formularz rezerwacji imprezy</h1>
            <p className="tac" style={{ marginBottom: '30px' }}>
              Wypełnij i wyślij poniższy formularz. Wrócimy do Ciebie z odpowiedzią najszybciej jak to możliwe!
            </p>
            
            <form className="event-form" onSubmit={handleSubmit}>
              {/* Dane kontaktowe */}
              <div className="form-section">
                <h3>Dane kontaktowe</h3>
                
                <div className="form-group">
                  <label htmlFor="name">Imię i nazwisko *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className={errors.name ? 'error' : ''}
                    required
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="email">E-mail *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={errors.email ? 'error' : ''}
                    required
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Telefon *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={errors.phone ? 'error' : ''}
                    required
                  />
                  {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>
              </div>

              {/* Detale imprezy */}
              <div className="form-section">
                <h3>Detale imprezy</h3>
                
                <div className="form-group">
                  <label htmlFor="eventType">Rodzaj imprezy</label>
                  <select
                    id="eventType"
                    name="eventType"
                    value={formData.eventType}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz rodzaj imprezy</option>
                    <option value="Impreza prywatna">Impreza prywatna</option>
                    <option value="Impreza firmowa">Impreza firmowa</option>
                  </select>
                </div>

                {formData.eventType === 'Impreza firmowa' && (
                  <div className="form-group">
                    <label htmlFor="companyName">Nazwa firmy</label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="eventDate">Data wydarzenia</label>
                  <input
                    type="date"
                    id="eventDate"
                    name="eventDate"
                    value={formData.eventDate}
                    onChange={handleInputChange}
                    className={errors.eventDate ? 'error' : ''}
                  />
                  {errors.eventDate && <span className="error-message">{errors.eventDate}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="eventHours">Godziny wydarzenia</label>
                  <select
                    id="eventHours"
                    name="eventHours"
                    value={formData.eventHours}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz godziny</option>
                    <option value="18:00 - 01:00">18:00 - 01:00</option>
                    <option value="19:00 - 02:00">19:00 - 02:00</option>
                    <option value="Inne">Inne - wskażę poniżej w pytaniach dodatkowych</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="guestCount">Ilość gości</label>
                  <div className="number-input-wrapper">
                    <input
                      type="number"
                      id="guestCount"
                      name="guestCount"
                      value={formData.guestCount}
                      onChange={handleInputChange}
                      min="1"
                    />
                    <div className="number-controls">
                      <button 
                        type="button" 
                        className="number-btn number-up"
                        onClick={() => handleNumberChange('guestCount', 1)}
                      >
                        ▲
                      </button>
                      <button 
                        type="button" 
                        className="number-btn number-down"
                        onClick={() => handleNumberChange('guestCount', -1)}
                      >
                        ▼
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="eventCharacter">Charakter wydarzenia</label>
                  <input
                    type="text"
                    id="eventCharacter"
                    name="eventCharacter"
                    value={formData.eventCharacter}
                    onChange={handleInputChange}
                    placeholder="Impreza firmowa, 50te urodziny, 18te urodziny..."
                  />
                </div>
              </div>

              {/* Opcje dodatkowe */}
              <div className="form-section">
                <h3>Opcje dodatkowe</h3>
                
                <div className="form-group">
                  <label htmlFor="drinks">Napoje</label>
                  <select
                    id="drinks"
                    name="drinks"
                    value={formData.drinks}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz opcję</option>
                    <option value="NAPOJE bezalkoholowe OD LOKALU">NAPOJE bezalkoholowe OD LOKALU</option>
                    <option value="NAPOJE bezalkoholowe WŁASNE">NAPOJE bezalkoholowe WŁASNE</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="alcohol">Alkohol</label>
                  <select
                    id="alcohol"
                    name="alcohol"
                    value={formData.alcohol}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz opcję</option>
                    <option value="ALKOHOL OD LOKALU wraz z Barmanem/Barmanami">ALKOHOL OD LOKALU wraz z Barmanem/Barmanami</option>
                    <option value="ALKOHOL WŁASNY bez Barmana">ALKOHOL WŁASNY bez Barmana</option>
                    <option value="BEZ ALKOHOLU">BEZ ALKOHOLU</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="catering">Catering</label>
                  <select
                    id="catering"
                    name="catering"
                    value={formData.catering}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz opcję</option>
                    <option value="CATERING OD LOKALU">CATERING OD LOKALU</option>
                    <option value="CATERING WŁASNY">CATERING WŁASNY</option>
                    <option value="BEZ CATERINGU">BEZ CATERINGU</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="djMusic">DJ / Muzyka</label>
                  <select
                    id="djMusic"
                    name="djMusic"
                    value={formData.djMusic}
                    onChange={handleInputChange}
                  >
                    <option value="">Wybierz opcję</option>
                    <option value="DJ oraz KARAOKE OD LOKALU">DJ oraz KARAOKE OD LOKALU</option>
                    <option value="WŁASNY DJ">WŁASNY DJ</option>
                    <option value="BEZ DJ'A z własną muzyką">BEZ DJ'A z własną muzyką</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="budget">Przewidywany budżet imprezy w PLN</label>
                  <input
                    type="text"
                    id="budget"
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    placeholder="Kwota lub przedział"
                  />
                </div>
              </div>

              {/* Dodatkowe informacje */}
              <div className="form-section">
                <h3>Dodatkowe informacje</h3>
                
                <div className="form-group">
                  <label htmlFor="additionalQuestions">Pytania i informacje dodatkowe</label>
                  <textarea
                    id="additionalQuestions"
                    name="additionalQuestions"
                    value={formData.additionalQuestions}
                    onChange={handleInputChange}
                    placeholder="Napisz jakie masz jeszcze do nas pytania oraz informacje dodatkowe, które usprawnią proces przygotowania dla Ciebie pięknej imprezy"
                    rows="4"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="source">Skąd się o nas dowiedziałeś?</label>
                  <input
                    type="text"
                    id="source"
                    name="source"
                    value={formData.source}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Zgody */}
              <div className="form-section">
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="regulationAccepted"
                      checked={formData.regulationAccepted}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="checkmark"></span>
                    Akceptuję regulamin lokalu dostępny pod adresem: singers.pl *
                  </label>
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="dataProcessingAccepted"
                      checked={formData.dataProcessingAccepted}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="checkmark"></span>
                    Wyrażam zgodę na przetwarzanie danych osobowych na potrzeby powyższego zapytania i rezerwacji *
                  </label>
                </div>
              </div>

              {/* Przycisk wysyłania */}
              <div className="form-submit">
                {submitMessage.text && (
                  <div className={`submit-message ${submitMessage.type}`}>
                    {submitMessage.text}
                  </div>
                )}
                <button 
                  type="submit" 
                  className={`submit-btn ${!isFormValid || isSubmitting ? 'disabled' : ''}`}
                  disabled={!isFormValid || isSubmitting}
                >
                  {isSubmitting ? 'Wysyłanie...' : 'Wyślij formularz'}
                </button>
                {!isFormValid && !isSubmitting && (
                  <p className="form-validation-info">
                    Wypełnij wymagane pola: imię i nazwisko, email, telefon oraz zaakceptuj regulamin i zgodę na przetwarzanie danych
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}